import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=554e8c0b&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('554e8c0b')) {
      api.createRecord('554e8c0b', component.options)
    } else {
      api.reload('554e8c0b', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=554e8c0b&", function () {
      api.rerender('554e8c0b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2CP8egDHABi0B/JS/comp/ImgFallback.vue"
export default component.exports